import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LinksComponent = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      sectionTitle: 'Quick Links',
      links: [
        {
          title: 'TN Government',
          logo: '/Images/ah1.png',
          url: 'https://www.tn.gov.in/'
        },
        {
          title: 'TN PDS',
          logo: '/Images/pds.png',
          url: 'https://tnpds.gov.in'
        },
        {
          title: 'TNCSC',
          logo: '/Images/tncsc.jpg',
          url: 'http://www.tncsc.tn.gov.in/'
        },
        {
          title: 'NABARD',
          logo: '/Images/nabard.png',
          url: 'https://www.nabard.org/'
        },
        {
          title: 'NCDC',
          logo: '/Images/ncdc.png',
          url: 'https://www.ncdc.in/'
        },
        {
          title: 'TRIFED',
          logo: '/Images/trifed.png',
          url: 'https://trifed.tribal.gov.in/'
        },
        {
          title: 'NAFED',
          logo: '/Images/Nafed-India.png',
          url: 'https://www.nafed-india.com/'
        }
      ]
    },
    ta: {
      sectionTitle: 'விரைவு இணைப்புகள்',
      links: [
        {
          title: 'தமிழ்நாடு அரசு',
          logo: '/Images/ah1.png',
          url: 'https://www.tn.gov.in/'
        },
        {
          title: 'தமிழ்நாடு PDS',
          logo: '/Images/pds.png',
          url: 'https://tnpds.gov.in'
        },
        {
          title: 'TNCSC',
          logo: '/Images/tncsc.jpg',
          url: 'http://www.tncsc.tn.gov.in/'
        },
        {
          title: 'நபார்ட்',
          logo: '/Images/nabard.png',
          url: 'https://www.nabard.org/'
        },
        {
          title: 'என்சிடிசி',
          logo: '/Images/ncdc.png',
          url: 'https://www.ncdc.in/'
        },
        {
          title: 'ட்ரைபெட்',
          logo: '/Images/trifed.png',
          url: 'https://trifed.tribal.gov.in/'
        },
        {
          title: 'நாபெட்',
          logo: '/Images/Nafed-India.png',
          url: 'https://www.nafed-india.com/'
        }
      ]
    }
  };

  const t = content[language];

  return (
    <section className="py-10 bg-gray-100" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>
      <div className="container mx-auto px-4">
        {/* Section Title */}
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">
            {t.sectionTitle}
          </h2>
          <div className="w-20 h-1 bg-gray-800 mx-auto"></div>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-5 max-w-[95%] mx-auto">
          {t.links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group block shadow-md transition-all duration-300 p-5 transform hover:-translate-y-2 hover:shadow-xl
                         bg-white border-2 border-gray-300
                         hover:border-gray-400
                         hover:bg-gray-50 flex items-center justify-center min-h-[140px]"
            >
              {/* Logo container */}
              <div className="w-full h-full flex items-center justify-center">
                <img
                  src={link.logo}
                  alt={link.title}
                  className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    const placeholder = document.createElement('div');
                    placeholder.className = 'w-16 h-16 bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center text-gray-700 text-lg font-semibold shadow-sm';
                    placeholder.textContent = link.title.charAt(0);
                    e.target.parentNode.appendChild(placeholder);
                  }}
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LinksComponent;